import Paper from "../components/Paper";
import ReposList from "../components/ReposList";

const Home = () => {
  return (
    <Paper>
      <ReposList />
    </Paper>
  );
};
export default Home;
